import { Component, OnInit,ViewEncapsulation } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Params } from '@angular/router';
import { IdiomasServiceN35 } from 'app/main/wizard-n35/services/idiomas.service';
import * as backInter from 'app/auth/auth-data.model';
import { ColaboradoresService } from 'app/main/wizard-cgo/services/colaboradores.service';
import { ColaboradoresEncuestadorService } from 'app/main/wizard-n35encuestador/services/colaboradoresEncuestador.service';
import { Subject } from 'rxjs';
import * as colabInter from './taskfiles.interface';
import { fuseAnimations } from '@fuse/animations';
///IDIOMAS
import { lang_wizard } from 'app/idiomas/i18n/wizard-guia/wizard.lang';
import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';
import {TranslateService} from '@ngx-translate/core';
import Swal from 'sweetalert2';
import { DATOS_API } from 'app/auth/auth.datos';
@Component({
  selector: 'app-taskfiles',
  templateUrl: './taskfiles.component.html',
  styleUrls: ['./taskfiles.component.scss'],
  encapsulation: ViewEncapsulation.None,
  animations : fuseAnimations
})
export class TaskfilesComponent implements OnInit {
  panelOpenState = false;
  productoCertificar: backInter.prodNorma35;
  opcTask: string[] = ['Winter', 'Spring', 'Summer', 'Autumn'];
  htp:string;
  urlServidor:string;
  private _unsubscribeAll: Subject<any>;
  idiomaActual:string;
  constructor(private formBuilder: FormBuilder,
    private colaboradoresService: ColaboradoresEncuestadorService,
    private activated: ActivatedRoute,
    private translateSrv: TranslateService,
    private _fuseTranslationLoaderService: FuseTranslationLoaderService,
    private idiomasService: IdiomasServiceN35) {
    this._unsubscribeAll = new Subject();
    lang_wizard.forEach((locale) => {
      this._fuseTranslationLoaderService.loadTranslations(locale);
    });
    this.translateSrv.onLangChange.subscribe(() => { this.cambiaIdiomaBanner(this.translateSrv.currentLang); });
    let url = DATOS_API.url.split(":");
    let htp = DATOS_API.url.split("/");
    this.htp = htp[0];
    this.urlServidor = url[1];
    console.log("Nuevas direcciones");
    console.log(this.urlServidor);

  }

  dataTasl:any;
  pathTmp= "http://104.154.162.169/surveyadministrator/backend/";
  tittleList: any;
  IdSeccionList: any;
  AllTaskList:any;
  cargando=true;
  idiomaBanner:any;
  dataTmpPrueba : [
    {
      titutlo: any,
      idSeccion: any,
    }
  ];
  ngOnInit() {
    this.cambiaIdiomaBanner(this.translateSrv.currentLang);
    this.obtieneCertificarActual();
    //console.log("Idioma act "+this.translateSrv.currentLang);
  }
  cambiaIdiomaBanner(idioma:string){
    console.log("idioma "+idioma);
    this.idiomaBanner = this.translateSrv.currentLang;
    switch(idioma){
      case 'es': this.idiomaBanner = idioma;
      break;
      default: this.idiomaBanner = 'en';
    }
    this.getBanner();
  }

  info:any;
  typeContent:any;
  ViewBetter:boolean=false;
  obtieneCertificarActual(){
    this.colaboradoresService.getProdCertAct().subscribe((data:backInter.infoProductos) => {
      let prodsCertificar:backInter.prodNorma35[] = data.productosNorma35;
      var BreakException = {};
      try {
          prodsCertificar.forEach( (producto) => {
            let fecha = producto.fechaNorma35;
            let idProducto = producto.idNorma35;
            console.log('productoID',localStorage.getItem('productoID'));
            console.log('fechaNorma',localStorage.getItem('FechaNorma'));
            if (fecha == parseInt(localStorage.getItem('FechaNorma')) && idProducto == localStorage.getItem('productoID')) {
            if(producto.completoNorma35 === 1){
              this.productoCertificar = producto;
              this.fechaCertificar=this.productoCertificar.fechaNorma35;
              this.typeContent=this.productoCertificar.tipo;
              console.log(this.productoCertificar);
              if(this.typeContent==2){
                this.ViewBetter=true;
              }
              this.getAllTask(this.fechaCertificar);    
              this.getChecked();
              throw BreakException;
            }
          }
          });
      } catch (e) {
          if (e !== BreakException) throw e;
      };
    }, error  => {
      console.log("error al recuperar certificar vigente");
    });
  }

  urlBanner:any;
  getBanner(){
    this.urlBanner = './assets/images/norm35/'+this.idiomaBanner+'/CG Norma 35-19.png';
  }
  fechaCertificar: any;
  data:any;
  arrayTodoList: any;
  arrayTmpList : any;
  rutaTmp: any;
  estadoCentro=false;
  arregloRutas = [
    {
      path: "",
    }
  ]
  ArraySecciones: Array<any> = [];
  ArrayNum: Array<any> = [];
  ArrayPath: Array<any> = [];
  Incisos: Array<any> = [];
  DescripcionIncisos: Array<any> = [];
  estatusColaboraodres=true;


  private getAllTask (fecha){
    this.data = {
      fechaDocumentador: fecha
    }
    var fechaTask;
    this.idiomasService.geTodoList(this.data).subscribe( (data : any)=>{
        this.arrayTodoList = data.secciones;
        this.colaboradoresService.getColaboradoresFast(this.productoCertificar.fechaNorma35, this.productoCertificar.idNorma35)
        .subscribe( (getFast: colabInter.getBDFast) => {
          this.info=this.colaboradoresService.getinfo();
          if(this.info.level==6){
            this.colaboradoresService.getColaboradores(this.productoCertificar.fechaNorma35,this.info.empresaPadre,this.productoCertificar.idNorma35)
            .subscribe( (response) => {
              console.log("Información CT");
              console.log(this.info);
              this.info.totalColaboradores;
              console.log(this.info.totalColaboradores);
              if(this.info.totalColaboradores>0){
                console.log("Entro mayor a 0");
                this.estadoCentro=true;
                this.estatusColaboraodres=false;
                if(this.info.totalColaboradores>50){
                  // El index 1 es encuesta de 16 a 50
                  this.arrayTodoList.splice(1,1);
                }else{
                  //El index 2 es el de más de 50
                  this.arrayTodoList.splice(2,1);
                }
                for(var i=0; i < this.arrayTodoList.length; i++){
                  this.getSeccion(this.arrayTodoList[i].nombreSeccion,i);
                   for(var k=0; k < this.arrayTodoList[i].tareas.length; k++){
                    fechaTask=this.arrayTodoList[i].tareas[k].fechaCreacion.toString();
                    this.arrayTodoList[i].tareas[k].fechaCreacion=fechaTask.substr(2,8);
                   }
                }
                console.log("Todo list");
                console.log(this.arrayTodoList);
              }
              // PENDIENTE
            });
          }

          if(getFast.message == 'Success' && getFast.numeroColaboradores > 0){
            this.estadoCentro=true;
            this.estatusColaboraodres=false;
            if(getFast.numeroColaboradores>50){
              // El index 1 es encuesta de 16 a 50
              this.arrayTodoList.splice(1,1);
            }else{
              //El index 2 es el de más de 50
              this.arrayTodoList.splice(2,1);
            }
            for(var i=0; i < this.arrayTodoList.length; i++){
              this.getSeccion(this.arrayTodoList[i].nombreSeccion,i);
               for(var k=0; k < this.arrayTodoList[i].tareas.length; k++){
                fechaTask=this.arrayTodoList[i].tareas[k].fechaCreacion.toString();
                this.arrayTodoList[i].tareas[k].fechaCreacion=fechaTask.substr(2,8);
               }
            }
            this.arrayTodoList.splice(9,1);
          }
          this.cargando=false;
          this.arrayTodoList.splice(8,1);

        });
    });
  }


  sendChecked(){
    let dataCorreo={
      productoId: this.productoCertificar.idNorma35,
      'correos':[
        {
          "email":"julie.villalobos@itbm.si"
        }
      ]
    };
    console.log(dataCorreo);
    console.log(this.productoCertificar.idNorma35);
    Swal.fire({
      width: '550px',
      title: "¿Está seguro de enviar a verificación sus tareas?", // advice 4
      icon: 'warning',
      showCancelButton: true,
reverseButtons: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: "Aceptar" ,
      cancelButtonText: "Cancelar", // advice 4
    }).then((result) => {
      if (result.value) {
        this.colaboradoresService.sendCheck(dataCorreo).subscribe((data:any) => {
          this.bloquearEvio=true;
          console.log("Respuesta del servicio");
          console.log(data);
          Swal.fire({
            icon: 'success',
            title: 'Su notificación ha sido enviada', // advice 5
            confirmButtonColor: '#e40601'
          });

        }, error  => {
          console.log(error);
        });

      }
    })


  }
  tmpChecked:any;
  bloquearEvio:boolean=false;
  getChecked(){
    let dataCorreo={
      productoId: this.productoCertificar.idNorma35,
    };

    this.colaboradoresService.getCheck(dataCorreo).subscribe((data:any) => {
      console.log("Respuesta del servicio get");
      console.log(data);
      this.tmpChecked=data.recordatoriosGuia;
      if(this.tmpChecked.length > 0){
        this.bloquearEvio=true;

      }


    }, error  => {
      console.log(error);
    });



  }

  private getSeccion (nombreseccion,pos){
    let pathTmp:any;
    switch(nombreseccion) {
      case "5.2 Identificar y analizar los factores de riesgo psicosocial": {
        pathTmp ="Política de prevención de riesgos psicosociales";
        this.ArrayPath[pos]="/NOM35/wizard/politica";
        this.ArraySecciones[pos]="WIZARD.PATRON.0.SECCION";
        this.ArrayNum[pos]="5.1";
        this.Incisos[pos]="a)	Evidencias documentales de la política de prevención de riesgos psicosociales";
        this.DescripcionIncisos[pos]="Los siguientes documentos sirven como evidencia de que se cuenta con una política que cumple con los incisos del punto 5.1 y las evidencias pertinentes para su implantación, mantenimiento y difusión.";
        break;
      }
      case "5.3 Identificar y analizar los factores de riesgo psicosocial": {
        pathTmp = "Encuesta 16-50 colaboradores";
        this.ArrayPath[pos]="/NOM35/wizard/encuesta-16-50";
        this.ArraySecciones[pos]="WIZARD.PATRON.1.SECCION";
        this.ArrayNum[pos]="5.2, 7.1a); 7.2; 7.4; 7.5; 7.6; 7.7; 7.8 y 7.9";
        this.Incisos[pos]="b)	Información del cuestionario aplicado";
        this.DescripcionIncisos[pos]="Los siguientes documentos sirven de evidencia para demostrar que los cuestionarios utilizados para la identificación y análisis de los factores de riesgo psicosociales son los que se encuentran en la guía de referencia II y III, cumpliendo con los métodos de evaluación descritos en esta.";
        break;
      }
      case "5.4 Adoptar las medidas para prevenir y controlar los factores de riesgo psicosocial":{
        pathTmp ="Encuesta más 50 colaboradores";
        this.ArrayPath[pos]="/NOM35/wizard/encuesta-50-mas";
        this.ArraySecciones[pos]="WIZARD.PATRON.2.SECCION";
        this.ArrayNum[pos]="5.3, 7.1b, 7.2; 7.3; 7.4; 7.5; 7.6; 7.7; 7.8 y 7.9";
        this.Incisos[pos]="b)	Información del cuestionario aplicado";
        this.DescripcionIncisos[pos]="Los siguientes documentos sirven de evidencia para demostrar que los cuestionarios utilizados para la identificación y análisis de los factores de riesgo psicosociales son los que se encuentran en la guía de referencia II y III, cumpliendo con los métodos de evaluación descritos en esta.";
        break;
      }
      case "5.5 Identificar a los trabajadores que fueron sujetos a acontecimientos traumáticos severos":{
        pathTmp ="Medidas de prevención y control";
        this.ArrayPath[pos]="/NOM35/wizard/medidas-preventivas&control ";
        this.ArraySecciones[pos]="Medidas de prevención y control";
        this.ArrayNum[pos]="5.4; 8.1; 8.2; 8.3; 8.4 y 8.5";
        this.Incisos[pos]="c)	Información de las medidas adoptadas para la prevención de los factores de riesgo psicosocial.";
        this.DescripcionIncisos[pos]="Los documentos que se enlistan a continuación contienen evidencia sobre las medidas adoptadas por el centro de trabajo para prevenir los factores de riesgo psicosociales ";
        break;
      }
      case "5.6 Practicar exámenes médicos y evaluaciones psicológicas":{
        pathTmp ="Canal de quejas y denuncias";
        this.ArrayPath[pos]="/NOM35/wizard/quejas-denuncias";
        this.ArraySecciones[pos]="WIZARD.PATRON.3.SECCION";
        this.ArrayNum[pos]="8.1";
        this.Incisos[pos]="";
        this.DescripcionIncisos[pos]="";
        break;
      }
      case "5.1 a) La prevención de los factores de riesgo psicosocial":{
        pathTmp ="Acciones y programas preventivos";
        this.ArrayPath[pos]="/NOM35/wizard/plan-acciones";
        this.ArraySecciones[pos]="WIZARD.PATRON.4.SECCION";
        this.ArrayNum[pos]="8.1, 8.2";
        this.Incisos[pos]="";
        this.DescripcionIncisos[pos]="";
        break;
      }
      case "5.1 b) La prevención de la violencia laboral":{
        pathTmp ="Programa de intervención con evaluaciones y medidas de control";
        this.ArrayPath[pos]="/NOM35/wizard/kpis";
        this.ArraySecciones[pos]="WIZARD.PATRON.5.SECCION";
        this.ArrayNum[pos]="8.3, 8.4, 8.5";
        break;
      }
      case "5.1 c) La promoción de un entorno organizacional favorable":{
        pathTmp ="Encuesta acontecimientos traumáticos severos";
        this.ArrayPath[pos]="/NOM35/wizard/encuesta-eventos-traumáticos";
        this.ArraySecciones[pos]="WIZARD.PATRON.6.SECCION";
        this.ArrayNum[pos]="5.5";
        this.Incisos[pos]="d)	Información de las medidas de control adoptadas en el centro de trabajo";
        this.DescripcionIncisos[pos]="Los documentos que se enlistan a continuación contienen evidencia sobre las medidas de control adoptadas por el centro de trabajo";
        break;
      }
      case "5.7 a) La política de prevención de riesgos psicosociales":{
        pathTmp="Exámenes médicos y evaluaciones psicológicas";
        this.ArrayPath[pos]="/NOM35/wizard/exámenes-médicos";
        this.ArraySecciones[pos]="WIZARD.PATRON.7.SECCION";
        this.ArrayNum[pos]="5.6";
        this.Incisos[pos]="e)	Información de las acciones adoptadas sobre los trabajadores identificados";
        this.DescripcionIncisos[pos]="La evidencia que se anexa a continuación se muestra información de los trabajadores identificados y las medidas adoptadas ";
        break;
      }
      case "5.7 b) Las medidas adoptadas para combatir las prácticas opuestas":{
        pathTmp ="Difusión y promoción de información";
        this.ArrayPath[pos]="/NOM35/wizard/alteraciones-salud";
        this.ArraySecciones[pos]="WIZARD.PATRON.8.SECCION";
        this.ArrayNum[pos]="5.7";
        this.Incisos[pos]="f)	Información sobre la comunicación, difusión y proporcionar información de as medidas adoptadas y mecanismos para sobre la NOM-035-STPS-2018.";
        this.DescripcionIncisos[pos]="A continuación, se presenta la evidencia de las acciones realizadas por el centro de trabajo para comunicar, difundir ";
        break;
      }
      case "5.7 c) Las medidas y acciones de prevención y, en su caso, las acciones ...":{
        pathTmp ="Registros";
        this.ArrayPath[pos]="/NOM35/wizard/registros";
        this.ArraySecciones[pos]="WIZARD.PATRON.9.SECCION";
        this.ArrayNum[pos]="5.8";
        this.Incisos[pos]="g)	Registros de las acciones realizadas en los trabajadores";
        this.DescripcionIncisos[pos]="La ultima evidencia que se presenta esta relacionada con los resultados de la identificación de los factores de riesgo psicosociales, las medidas adoptadas de este análisis y los trabajadores a los que se les practicaron los exámenes o evaluación correspondientes";
        break;
      }

   }


  }







}
